import React, { Suspense, lazy, useEffect, useState } from "react"; // Import useEffect and useState
import {Intro} from "../components/About";
import AnnualStats from "../components/AnnualStats";
import Leaderboard from "../components/Leaderboard";
import Loading from "../components/Loading"; // Assuming you have a Loading component
import { authFetch } from "../utils/api";
import { useAuth } from "../utils/auth";
// import PreviewCarousel from "../components/PreviewCarousel";

// Plotly is large; only logged-in users see the chart, so keep it out of the main bundle.
const MonthlyStats = lazy(() => import("../components/MonthlyStats"));

const Home = () => {
    const { REACT_APP_CLIENT_ID } = process.env;
    const redirectUrl = process.env.NODE_ENV === "development" ? "http://localhost:3000/redirect" : "http://strollerstats.com/redirect";
    const handleLogin = () => {
        window.location = `http://www.strava.com/oauth/authorize?client_id=${REACT_APP_CLIENT_ID}&response_type=code&redirect_uri=${redirectUrl}/exchange_token&approval_prompt=force&scope=read,activity:read,activity:write,activity:read_all`;
    };
    const { user } = useAuth();
    const user_id = user ? user.uid : null;

    const [optedInToKilometers, setOptedInToKilometers] = useState(null); // null initially, will be true/false after fetch

    useEffect(() => {
        const fetchUserPreference = async () => {
            if (user_id) {
                try {
                    const userResponse = await authFetch("/me");
                    if (!userResponse.ok) {
                        throw new Error(`HTTP error! status: ${userResponse.status}`);
                    }
                    const userData = await userResponse.json();
                    setOptedInToKilometers(userData.opted_in_kilometers || false);
                } catch (error) {
                    console.error("Error fetching user preferences:", error);
                    setOptedInToKilometers(false);
                }
            }
        };

        fetchUserPreference();
    }, [user_id]);

    const renderContent = () => {
        if (user_id == null) {
            return (
                <div>
                    <h1>Track your stroller miles with Stroller Stats.</h1>
                    <Intro />
                    <br></br>
                    <button className="authButton" onClick={handleLogin}>
                        <img src="/btn_strava_connect_with_orange.png" alt="Connect with Strava" />
                    </button><br></br>
                    <h2>Sign in with Strava and let's get rolling! <div className="bounceArrow">^</div></h2>
                    {/* <PreviewCarousel /> */}
                </div>
            );
        } else {
            return (
                <>
                    <AnnualStats userId={user_id} />
                    <Suspense fallback={<Loading />}>
                        <MonthlyStats userId={user_id} optedInToKilometers={optedInToKilometers} />
                    </Suspense>
                    <Leaderboard userId={user_id} optedInToKilometers={optedInToKilometers} />
                </>
            );
        }
    };

    return (
        <main>
            {renderContent()}
        </main>
    );
};

export default Home;